import React, {useState, useEffect, useCallback} from 'react';
import api from '../contexts/BaseUrl'
import './StockMaterials.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';


function StockMaterials(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');

    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');

    
    const [productionDescription, setProductionDescription] = useState('');
    const [totalPrice,setTotalPrice] = useState('');


  
    var url;

    if(searchSalesAssignedTo.length>0){
        url = `rawmaterials/get-all-raw-materials?materialsName=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=40`
    }
    else{
        url = `rawmaterials/get-all-raw-materials?pageNumber=${pageNumber}&pageSize=20` ;
    }


   


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllDailyExpenses = useCallback( async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    const fetchDailyExpenseDetails = (e) => {
        setIsEditLoading(true);
        api.get(`rawmaterials/get-raw-material?materialsId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.rawMaterialsId);
            setSelectedDate(response.data.rawMaterialsDate);
            setProductionDescription(response.data.rawMaterialsName);
            setTotalPrice(response.data.rawMaterialsAmount);
            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    useEffect(() => {
        fetchAllDailyExpenses();
    },[fetchAllDailyExpenses])

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`rawmaterials/create-raw-materials`,{
            rawMaterialsDate: selectedDate,
            rawMaterialsName: productionDescription,
            rawMaterialsAmount: totalPrice,

        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllDailyExpenses();
            setIsLoading(false);
            setSelectedDate('');
            setProductionDescription('');
            setTotalPrice('');
            setAddSale(0);
        }).catch(err =>{
            setIsError(true);
            setIsLoading(false);
            setSelectedDate('');
            setProductionDescription('');
            setTotalPrice('');
        })
    }

    const closeAddSale = (e) => {
        setSelectedDate('');
        setProductionDescription('');
 
        setTotalPrice('');
        setAddSale(0);
    }

    const showEditSale = (e) => {
        fetchDailyExpenseDetails(e);
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
  
        setTotalPrice(); 
        setIsEditLoading(false);
        fetchAllDailyExpenses();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`rawmaterials/edit-raw-materials`,{
            rawMaterialsId: saleId,
            rawMaterialsName: productionDescription,
            rawMaterialsDate: selectedDate,
            rawMaterialsAmount: totalPrice,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setProductionDescription('')
   
            setTotalPrice('');
            setIsEditLoading(false);
            fetchAllDailyExpenses();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            setIsEditLoading(false);
            setSelectedDate('');
            setProductionDescription('')
        
            setTotalPrice('');
        })
    }

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.post(`rawmaterials/delete-raw-material`,{
            materialsId: saleId,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setProductionDescription('')
            setTotalPrice('');
            setIsDeleteLoading(false);
            fetchAllDailyExpenses();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setProductionDescription('')

            setTotalPrice('');
        })
    }
 
    return(
        <div className='stockMaterialsPage'> 
    
           <LeftPanel 
                tabName='stock-materials'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                           

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by Materials Name'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                        </div>
                       <div>{
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit Materials</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={() => setAddSale(1)}
                            >Add Materials</button>
                       </div>
                        
                    </div>
                    <div id='tableBox'>
                    {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Materials Name</th>
                                    
                                    <th>Quantity</th>
                                    
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                                
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.rawMaterialsDate.substring(0, 10)}</td>
                                        <td>{item.rawMaterialsName}</td>
                                        <td>{item.rawMaterialsAmount}</td> 


                                        
                                        {editSale ===1 && <td onClick={() => showEditSale(item.rawMaterialsId)} style={{cursor:'pointer'}}>Edit</td>}
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeAddSale}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Materials</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                           
                            
                        </div>
                        
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Materials Name:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Type materials name'
                                    required
                                    onChange={(e) => setProductionDescription(e.target.value)}
                                    value={productionDescription}
                                />
                            </div>
                           
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Quantity: </div>
                                <input
                                    id='amount'
                                    placeholder='Type quantity'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            
                        </div>
                      
                        {isError && 
                            <div id='errorMsg'>Failed adding new expense! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Materials</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Materials</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeDesignation'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>

                             
                        </div>

                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Materials Name:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Type productin description'
                                    required
                                    onChange={(e) => setProductionDescription(e.target.value)}
                                    value={productionDescription}
                                />
                            </div>
                           
                        </div>
                        
                      
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Quantity: </div>
                                <input
                                    id='amount'
                                    placeholder='Type quantity'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            
                        </div>
                     
                        {isError && 
                            <div id='errorMsg'>Failed updating production! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting production! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Materials</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default StockMaterials;